import React, { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { CircularProgress } from "@mui/material";
// Import the exact icon you used in the reference
import SubMenuThreeDotIcon from "../../../../components/icons/SubMenuThreeDotIcon";
// Import your SCSS if needed (assuming styles are global or shared)
import "./PropertyBankActionMenu.scss";

const PropertyBankActionMenu = ({
  status,
  onStatusChange,
  isLoading,
}: {
  status: string;
  onStatusChange: (newStatus: string) => void;
  isLoading?: boolean;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (actionType: "toggle" | "delete") => {
    handleClose();

    if (actionType === "delete") {
      // Logic: Set status to trash
      onStatusChange("trash");
    } else {
      // Logic: Toggle between 'disabled' and 'agent_validated' (or admin_draft)
      const newStatus =
        status === "disabled" || status === "deactivated"
          ? "agent_validated" // Activate
          : "disabled"; // Disable
      onStatusChange(newStatus);
    }
  };

  return (
    <>
      {/* Same Design Wrapper */}
      <div
        className="agent-menu-icon"
        onClick={handleClick}
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        style={{ cursor: "pointer" }}
      >
        {isLoading ? (
          <CircularProgress
            style={{ width: 15, height: 15 }}
            className="circular-progress-action-icon"
          />
        ) : (
          /* Same Icon Component */
          <SubMenuThreeDotIcon />
        )}
      </div>

      {/* Same Menu Structure */}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        className="users-list-menu-icon-menu"
        autoFocus={false}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={() => handleAction("toggle")}>
          {status === "disabled" || status === "deactivated"
            ? "Activate"
            : "Disable"}
        </MenuItem>

        <MenuItem onClick={() => handleAction("delete")}>Delete</MenuItem>
      </Menu>
    </>
  );
};

export default PropertyBankActionMenu;
